var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonAddOutline = function SvgPersonAddOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.892 6.029c-.177 2.366-1.977 4.297-3.954 4.297-1.976 0-3.78-1.93-3.953-4.297-.18-2.462 1.573-4.297 3.954-4.297 2.38 0 4.132 1.88 3.953 4.297Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M12.938 13.19c-3.908 0-7.875 2.149-8.609 6.204-.09.488.19.958.703.958h15.812c.514 0 .792-.47.703-.958-.734-4.055-4.7-6.204-8.609-6.204Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.953 7.46v5.014M6.47 9.967H1.437"
  })));
};
export default SvgPersonAddOutline;